module.exports = __webpack_public_path__ + "static/media/5.554e7f4b.jpg";